import React from 'react';
import { Moon, Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-162">
      {/* Decorative background elements */}
      <div className="absolute top-20 left-10 text-accent/20 animate-pulse" data-id="element-163">
        <Star size={40} data-id="element-164" />
      </div>
      <div className="absolute top-40 right-20 text-accent/20" data-id="element-165">
        <Moon size={60} data-id="element-166" />
      </div>

      <div className="max-w-6xl mx-auto px-6" data-id="element-167">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-168">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left z-10" data-id="element-169">
            <FadeIn data-id="element-170">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 text-brown text-sm font-semibold tracking-wide mb-6 shadow-sm border border-accent/20" data-id="element-171">
                <Moon size={16} className="text-accent" data-id="element-172" />
                <span data-id="element-173">Para bebés de 0 a 12 meses</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.05} data-id="element-174">
              <p className="text-base md:text-lg text-accent font-semibold italic mb-4" data-id="element-175">
                Si llegaste aquí porque tu bebé no te deja dormir y ya no sabes
                qué más hacer... estás en el lugar correcto.
              </p>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-176">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown-dark leading-tight mb-6" data-id="element-177">
                ¿Tu bebé no te deja dormir?{' '}
                <span className="text-brown italic" data-id="element-178">
                  Descubre el Método de Micro-pausas Nocturnas y recupera noches
                  más tranquilas en 48 horas.
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-179">
              <h2 className="text-xl md:text-2xl text-brown/80 font-serif mb-8" data-id="element-180">
                Un plan flexible para madres agotadas con bebés de 0 a 12 meses,
                sin rutinas rígidas ni dejarlo llorar solo.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-181">
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 text-sm text-brown-dark/70 font-medium mb-6" data-id="element-182">
                <span className="bg-white/60 px-3 py-1 rounded-full border border-accent/20" data-id="element-183">
                  Acceso inmediato
                </span>
                <span className="bg-white/60 px-3 py-1 rounded-full border border-accent/20" data-id="element-184">
                  Incluye 3 bonos gratis
                </span>
                <span className="bg-white/60 px-3 py-1 rounded-full border border-accent/20" data-id="element-185">
                  Resultados en las primeras 48 horas
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-186">
              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start" data-id="element-187">
                <Button href="#oferta" data-id="element-188">Descarga la Guía por solo $9.99</Button>
                <p className="text-sm text-brown/70 font-medium" data-id="element-189">
                  y empieza hoy mismo.
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="flex-1 relative w-full max-w-md mx-auto" data-id="element-190">
            <FadeIn delay={0.3} direction="left" data-id="element-191">
              <div className="relative group" data-id="element-192">
                <div className="absolute -inset-4 bg-accent/20 rounded-3xl blur-xl group-hover:bg-accent/30 transition duration-500" data-id="element-193"></div>
                <img src="https://cdn.magicpatterns.com/uploads/9RPM76vXYgSvM75V8REp9H/imagen_portada_guia_de_sueno_express_para_bebes_2.png" alt="Portada de la Guía de Sueño Express para Bebés mostrando a una madre abrazando a su bebé" className="relative rounded-2xl shadow-2xl transform -rotate-2 group-hover:rotate-0 transition-all duration-500 border-8 border-white" data-id="element-194" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}